import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import * as React from "react";
import Render from "source/app/presentation/Shared/Render";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";
import { ShowGoalName } from "./ShowGoalName";

export function ShowGoalNameSuggestions({
    state,
    SaveAction,
}: {
    state: ICalendarEventEditorState;
    SaveAction: (withEventData?: ICalendarEvent) => Promise<void>;
}) {
    if (state.calendarEvent.name.length < 2) {
        return null;
    }

    const isAlreadyExactMatch =
        state.matchingGoals.length === 1 &&
        state.matchingGoals[0].name === state.calendarEvent.name;

    if (isAlreadyExactMatch) {
        return null;
    }

    return (
        <div>
            {state.matchingGoals.map((goal) => (
                <ShowGoalName
                    key={goal.id}
                    {...{ goalName: goal.name, state, SaveAction }}
                />
            ))}
            <Render
                id="singleMatchingGoalInfoText"
                when={state.matchingGoals.length === 1}
            >
                <div
                    className={StyleClassAuto({
                        fontSize: "9px",
                        color: "yellowgreen",
                        marginBottom: `10px`,
                    })}
                >
                    press Enter to choose this goal
                </div>
            </Render>
            <Render
                id="noMatchingGoalsInfoText"
                when={
                    state.matchingGoals.length === 0 &&
                    state.calendarEvent.name !== ``
                }
            >
                <div
                    className={StyleClassAuto({
                        fontSize: "9px",
                        color: "yellowgreen",
                        marginBottom: `10px`,
                    })}
                >
                    press Enter to save event
                </div>
            </Render>
        </div>
    );
}
